import { useDispatch, useSelector } from 'react-redux';
import { FaPaypal, FaLine } from 'react-icons/fa';
import { savePaymentMethod } from '../../slices/cartSlice';
import SectionTitle from './SectionTitle';

// Payment section: same single-method choice as PaymentScreen. Reads/writes
// cartSlice.paymentMethod. Actual PayPal capture still happens on the order
// confirmation screen after the order is created (unchanged backend flow).
//
// UI polish: the bare radio is now a selectable card that matches the
// ShippingMethods carrier cards. It is still a real <input type="radio">
// inside a <label>, so keyboard + screen-reader behavior is native.
const PAYMENT_METHODS = [
  {
    id: 'PayPal',
    label: 'PayPal 或信用卡',
    subtitle: '送出訂單後，於下一頁安全付款',
    icon: <FaPaypal />,
  },
  {
    // LINE Pay: after placing the order, OrderScreen shows a LINE Pay button
    // that sends the user to LINE's payment page (server-side request/confirm).
    id: 'LinePay',
    label: 'LINE Pay',
    subtitle: '送出訂單後，前往 LINE Pay 完成付款',
    icon: <FaLine />,
    iconClass: 'is-line',
  },
];

const PaymentSection = () => {
  const dispatch = useDispatch();
  const { paymentMethod } = useSelector((state) => state.cart);

  return (
    <>
      <SectionTitle step={4}>付款方式</SectionTitle>
      <fieldset>
        <legend className="op-subtitle h6">選擇付款方式</legend>
        <div className="d-flex flex-column" style={{ gap: '10px' }}>
          {PAYMENT_METHODS.map((m) => {
            const active = paymentMethod === m.id;
            return (
              <label
                key={m.id}
                htmlFor={m.id}
                className={`op-choice ${active ? 'is-active' : ''}`}
              >
                <span className={`op-choice-icon ${m.iconClass || ''}`} aria-hidden="true">
                  {m.icon || <FaPaypal />}
                </span>
                <span className="flex-grow-1">
                  <span className="op-choice-name">{m.label}</span>
                  <span className="op-choice-sub">{m.subtitle}</span>
                </span>
                <input
                  type="radio"
                  className="form-check-input"
                  id={m.id}
                  name="paymentMethod"
                  value={m.id}
                  checked={active}
                  onChange={(e) => dispatch(savePaymentMethod(e.target.value))}
                />
              </label>
            );
          })}
        </div>
      </fieldset>
    </>
  );
};

export default PaymentSection;
